import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';

import { IBillingCycleRes, ISaveBillingCycleReq } from './index.type';

const useSaveBillingCycle = () => {
  const { loading: saveBillingCycleLoading, makeApiCall } = useApi({
    url: `/rtm/billing-cycle/activate`,
    method: 'PATCH',
  });

  const saveBillingCycleData = async (formData: ISaveBillingCycleReq) => {
    const { response, error } = await makeApiCall<ISaveBillingCycleReq, IBillingCycleRes>(formData);

    if (response?.status === 'success') {
      return response;
    }
    if (response?.status === 'fail') {
      toast.error(response.msg);
    }
    if (error) {
      toast.error(error.msg || 'Something went wrong while fetching state. Please try again later');
    }
  };

  return {
    saveBillingCycleData,
    saveBillingCycleLoading,
  };
};

export default useSaveBillingCycle;
